import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import {ArmyListView} from "@Selectors/builder/myBuilder/show/view/ArmyListView";
import {getUserPreference} from "@Selectors/profile/selector/getUserPreference";
import {VersionInterface} from "@Models";
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom';

interface IArmyListComponentProps {
  armyList: ArmyListView
}

const getVersionColor = (color: string) => ({
  borderColor: `transparent transparent ${color} transparent`
});

const ArmyListComponent: React.FC<ArmyListComponentProps> = ({armyList, builderInterface}) => {
  const currentLocale = document.documentElement.lang;
  let link = '';
  if(builderInterface === VersionInterface.OldSkool)
    link = '?minimal=true'
  return (
    <Col xs={6} md={3} xl={2} className="army_list_row text-center">
      <Link to={`/${currentLocale}/builder/army_lists/${armyList.id}${link}`}>
        {armyList.logo !== null && <img className="img-fluid w-100" alt={armyList.initials} src={`${process.env.CDN ?? ''}${armyList.logo}`} />}
        <h4 className="boxtitre">{(armyList.name || '').substring(0, 60)}</h4>
      </Link>
      <div className="tourne mt-3 me-4" style={getVersionColor(armyList.versionColor)}>{armyList.versionName}</div>
    </Col>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArmyListComponentProps) => ({
  armyList: owsProps.armyList,
  builderInterface: getUserPreference(state)?.builderInterface
})

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListComponent);

type ArmyListComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
